import { Skeleton } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 4px 0;
`;

export const SkeletonCard = styled(Skeleton)`
  border-radius: 8px;
`;
